import { Component, SimpleChanges, ViewChild } from '@angular/core';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { default as GridColumnsJSON } from 'app/Shared/Constant/Grid Column Names/Comparative-Review-Columns.json';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'app/Shared/Services/user.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { Subscription } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { MessageService } from 'primeng/api';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { ActivatedRoute } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QuickSearchComponent } from 'app/Shared/Component/quick-search/quick-search.component';
import { Table, TableModule } from 'primeng/table';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { LowerCasePipe, NgClass, CommonModule, UpperCasePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { UrlsService } from '../../../../Shared/Services/urls.service';
import { SharedHttpClientService } from '../../../../Shared/Services/shared-http-client.service';
import { DataService } from 'app/Shared/Services/data.service';
import { CommentViewerComponent } from 'app/Shared/Component/comment-viewer/comment-viewer.component';
import { EventTreeService } from 'app/Shared/Component/event-tree/event-tree.service';
import { EventTreeDialogComponent } from 'app/Shared/Component/event-tree/event-tree-dialog.componenet';
import { SymbolPanelComponent } from 'app/Shared/Component/symbol-panel/symbol-panel.component';
import { CompReviewServiceService } from '../comp-review-service.service';
import { CompReviewViewDetailsComponent } from '../comp-review-view-details/comp-review-view-details.component';
import { CommentViewerService } from 'app/Shared/Component/comment-viewer/comment-viewer.service';


@Component({
  selector: 'app-comp-exception-details',
  standalone: true,
  imports: [FilterPanelComponent, MatProgressSpinner, MatTooltipModule,
    QuickSearchComponent, TableModule, ExportToCSVSComponent,CommonModule,
    LowerCasePipe, NgClass, ButtonModule, FormsModule,
    CommentViewerComponent, UpperCasePipe,
    EventTreeDialogComponent, SymbolPanelComponent, CompReviewViewDetailsComponent],
  templateUrl: './comp-exception-details.component.html',
  styleUrl: './comp-exception-details.component.scss',
  providers: [CommentViewerService]
})
export class CompExceptionDetailsComponent {
  @ViewChild(('dt')) dt!: Table;
  GridColumns: any;
  columnJson: any = [];
  cols: any = []
  dataset1: any[] = [];
  ActiveSymbol: any;
  SymbolsArray: any = [];
  DefaultFilterArray: any = [];
  isLoadingResults = true;
  isDataLoadingResults: boolean = false;
  ExceptionCode: any = '';
  CATFieldTypesArrayList: any = [];
  quickFilterArray: any;
  sortData: any = { field: '', order: 0 };
  sortClickCounter: number = 0;
  defaultData: any;
  rowsPerPageOptions: any = [];
  selectedRow: any = [];
  selectedRowLength!: number;
  isDisplayAddCommentForm:boolean = true;



  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  totalRecords: any;
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  pageNumber: any = 1;
  priviousStartLimit: any;
  subscription!: Subscription;
  View: boolean = false;
  filterFieldDefaultValues: any = new Object();
  rowDataforDialog: any;
  rowIndexForDialog!: number;
  actionType!: string;
  edit!: boolean;
  correctCodeLength: number = 0;
  isDisplayCommentDialog: boolean = false;
  isDisplayEventTreeDialog: boolean = false;
  queryCommentGridColumns: any;
  commentAPIDetail: any;
  commentStaticFilters: any
  ApplicationName: any = '';
  CodesArray: any = [];
  resetLabel: any;


  constructor(
    public userService: UserService,
    private readonly gridService: GridService,
    private readonly emitterService: EmitterService,
    public constantService: ConstantService,
    private readonly messageService: MessageService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly UrlsService: UrlsService,
    private readonly sortPipe: SortPipe,
    public dataService: DataService,
    private readonly SharedHttpClientService: SharedHttpClientService,
    public readonly compReviewServiceService: CompReviewServiceService,
    public eventTreeService: EventTreeService,
    public readonly commentViewerService: CommentViewerService
  ) {
    this.GridColumns = GridColumnsJSON['GridColumns'];
    this.quickFilterArray = GridColumnsJSON['quick-Search-Filter'];
    this.queryCommentGridColumns = GridColumnsJSON['query-comment-columns'];

    this.CATFieldTypesArrayList = this.userService.getDropDownList('type');
    const deaultEventTypeValues = this.CATFieldTypesArrayList.map((rowObj: any) => rowObj.value);
    this.filterFieldDefaultValues = { type: deaultEventTypeValues };

    this.ApplicationName = this.constantService.getApplicationName();
    this.getBrowseCommentViewerCount();
  }

  ngOnInit(): void {
    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.totalRecords = this.rowcount;
    this.dataset1 = [];
    this.ExceptionCode = this.activatedRoute.snapshot.paramMap.get('Code');
    this.getColumns();
    this.rowsPerPageOptions = this.constantService.DEFAULT_ROWSPERPAGEOPTION;
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe({
      next: (value: any) => {
        if (value) {
          this.getData();
          this.getSymbols();
          this.getFailureCodeSummary();
        }
      }
    });
    this.getLastReportDate();

  }

  getLastReportDate() {
    this.defaultFilter();
  }


  FilterEventClearSymbol(event: any) {
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.emitterService.ResetQuickFilterPanelEvent.emit("Symbol");
  }
  FilterEventClearCode(event: any) {
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.emitterService.ResetQuickFilterPanelEvent.emit("Code");
  }


  FilterApplyFilterEvent(event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.compReviewServiceService.LastExecutionCompDate= event[0]["values"];
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.getSymbols();
    this.getFailureCodeSummary();
    this.getBrowseCommentViewerCount();
    this.getData();
  }

  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
    }
  }

  GridResetSymbolEvent(event: any) {
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.emitterService.ResetQuickFilterPanelEvent.emit('All');
  }

  GridChangeLimitEvent(event: any) {
    this.Limit = event;
    this.getData();
  }


  defaultFilter() {
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'reportDate', 'filterby': '', 'values': this.compReviewServiceService.LastExecutionCompDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Type', 'columnname': 'type', 'filterby': 'IS', 'values': [], 'time': '', 'datatype': 'skip', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect', 'dropdownvalue': this.CATFieldTypesArrayList },
      {
        isdefault: 'true',
        label: 'Status',
        columnname: 'status',
        filterby: 'IN',
        values: [],
        time: '',
        datatype: 'Array',
        disabled: 'true',
        dropdown: 'YES',
        dropdowntype: 'multiselect',
        dropdownvalue: this.constantService.statusDropDwn,
      },
      { 'isdefault': 'true', 'label': 'Firm ROEID', 'columnname': 'firmROEID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Symbol', 'columnname': 'symbol', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Order ID', 'columnname': 'orderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Routed OrderID', 'columnname': 'routedOrderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Trade ID', 'columnname': 'tradeId', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Destination', 'columnname': 'destination', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'GroupName', 'columnname': 'groupName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Failure Code', 'columnname': 'failureCode', 'filterby': '=', 'values': this.ExceptionCode, 'time': '', 'datatype': 'int', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
    ];
    this.getData();
    this.getSymbols();
    this.getFailureCodeSummary()

  }
  getData() {
    this.previousLimit = this.Limit;
    this.isDataLoadingResults = true;
    this.gridService.getData(
      APIURL.Comparative_Review_Exception,
      this.DefaultFilterArray,
      this.Limit,
      this.gridService.getEventsList(this.DefaultFilterArray, 'Type'),
      "Comparative-Review-Exception"
    ).subscribe({
      next: (Element: any) => {
        this.isDataLoadingResults = false;
        let dataset: any = Element;
        this.dataset1 = dataset.Data;
        this.defaultData = this.dataset1;
        this.totalRecords = dataset.totalCount;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
      }, error: (err: HttpErrorResponse) => {
        this.dataset1 = [];
        this.totalRecords = 0;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        this.isDataLoadingResults = false;
      }
    });

  }

  exportToCSV(response: any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    let exportLimt: any;
    let reportDate = this.userService.getyyyyMMddDateFormate(this.compReviewServiceService.LastExecutionCompDate[0]);
    if (response.isExportMaxRows) {
      exportLimt = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      exportLimt = this.previousLimit;
    }
    this.gridService.getData(
      APIURL.Comparative_Review_Exception,
      this.DefaultFilterArray,
      exportLimt,
      this.gridService.getEventsList(this.DefaultFilterArray, 'Type'),
      "Comparative-Review-Exception"
    ).subscribe({
      next: (Element: any) => {

        let dataset: any = Element;
        let data = dataset.Data;
        let title = 'RSMS_Comparative-Review-Exception_' + reportDate;

        if (data.length > 0) {
          data.forEach((col: { originalJSON: any; }) => {
            delete col.originalJSON;
          });
          const options: any = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: title,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
            filename: this.userService.getActiveMPID() + title + "_" + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
          };
          const csvData = this.constantService.getExportData(data, response.gridColumn);
          const csv = generateCsv(options)(csvData);
          const blob = asBlob(options)(csv);
          saveAs(blob, options.filename);

          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'No data found',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
        this.emitterService.exportToCSVData.emit(true);

      }, error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'Error while Exporting',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
    });
  }
  updateDefaultArray($event: any) {
    this.DefaultFilterArray = $event;
    this.getSymbols();
    this.getFailureCodeSummary()
    this.getData();
  }
  onActiveSymbolEvent(event: any) {
    this.ActiveSymbol = event;
    for (const element of this.DefaultFilterArray) {
      if (element.label.toLocaleLowerCase() == 'symbol') {
        element.values = this.ActiveSymbol;
        this.startLimit = 0;
        this.Limit.Start = 0;
        this.pageNumber = 1;
        this.dt.first = this.startLimit;
        this.totalRecords = 0;
        this.emitterService.ReloadQuickFilterPanelEvent.emit("true");
        this.getData();
      }
    }
  }

  onActiveCodeEvent(event: any) {
    let ActiveCode: number = event;
    for (const element of this.DefaultFilterArray) {
      if ((element.label).toLocaleLowerCase() == 'failure code') {
        element.values = ActiveCode;
        this.startLimit = 0;
        this.Limit.Start = 0;
        this.pageNumber = 1;
        this.dt.first = this.startLimit;
        this.emitterService.ReloadQuickFilterPanelEvent.emit("true");
        this.getData();
      }
    }
  }

  clearQuickSearch($event: any) {
    this.DefaultFilterArray = $event;
    this.getSymbols();
    this.getFailureCodeSummary()
    this.getData();
  }
  changePage(event: { first: any; rows: number; }) {
    this.startLimit = event.first;
    this.rowcount = event.rows;
    this.endLimit = this.startLimit + this.rowcount;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    this.getData();
  }
  sort(event: any) {
    if (this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if (this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.dataset1 = this.sortPipe.transform(this.dataset1, this.sortData.order, this.sortData.field);
    } else {
      this.resetSort()
    }

  }
  resetSort() {
    if (this.dt.multiSortMeta != undefined && this.dt.multiSortMeta?.length > 0) {
      this.dt.multiSortMeta[0].field = '';
      this.dt.multiSortMeta[0].order = 0;
    }

    this.dataset1 = this.defaultData;
  }

  onRowSelect(value: any, index: any, rowData: any) {
    this.dataService.roeSelectedRecords = this.dataService.checkRowExistanceInList(rowData, this.dataService.roeSelectedRecords, 'firmROEID'); // Check Row Object Existance in selected Row Object List
    if (this.dataService.roeSelectedRecords.length <= 1) {
      this.dataService.roeSelectedRecords = [];
      this.dataService.roeSelectedRecords[0] = (rowData)
    }
    this.correctCodeLength = 0;
    if (value == 'View') {
      this.selectedRow = [];
      this.selectedRow[0] = rowData;
      this.rowDataforDialog = rowData;
      this.rowIndexForDialog = index;
      this.actionType = value;
      this.edit = true;
    } else if (["Comment"].includes(value)) {
        this.isDisplayAddCommentForm=true;
        this.selectedRow = [];
        this.selectedRow[0] = rowData;
      // Comment Detail
      this.commentAPIDetail = {
        "GetCommentURL": APIURL.Comp_Review_Get_Comments,
        "AddCommentURL": APIURL.Comp_Review_Add_Comment,
        "Module": "Comparative-Review-Exceptions"
      };
      // Static Filters for Comment-Viewer Dialog
      this.commentStaticFilters = [{ filterName: 'Report Date', filterValue: rowData.reportDate, fieldName: 'reportDate' }];

      this.dataService.roeSelectedRecords = [...this.selectedRow]
      this.isDisplayCommentDialog = true; // open Comment-Viewer Dialog
    }
    else {
      this.dataService.roeSelectedRecords = [];
      this.dataService.roeSelectedRecords[0] = (rowData)
      if (value == 'OrderID') {
        this.selectedRow = [];
        this.selectedRow[0] = rowData;
        this.emitterService.isOrderViewerOpenCloseEvent.emit(
          {
            display: true,
            rowData: rowData,
            pageName: 'Comparative-Review-Exception'
          });
      }
    }
  }

  onEventTree(rowData: any) {
    this.eventTreeService.isDialogOpen = true;
    this.isDisplayEventTreeDialog = true;
    this.selectedRow = [];
    this.selectedRow[0] = rowData
  }

  closeAllDialogs(value: any) {
    this.dataService.roeSelectedRecords = [];
    this.edit = false;
    this.View = false;
    this.isDisplayCommentDialog = false;
    this.isDisplayEventTreeDialog = false;
    this.eventTreeService.isDialogOpen = false;
  }


  getSymbols() {
    this.SymbolsArray = [];
    this.isLoadingResults = true;
    this.gridService.getSymbol(APIURL.QuickFilterFields, this.DefaultFilterArray, this.Limit, "Comparative-Review-Exception")
      .subscribe({
        next: (Element: any) => {
          this.isLoadingResults = false;
          this.SymbolsArray = [];
          let Filter: any = Element;
          this.SymbolsArray = Filter.SymbolList;
        }, error: (err: HttpErrorResponse) => {
          this.isLoadingResults = false;

        }
      });
  }
  getFailureCodeSummary() {
    this.CodesArray = [];
    this.isLoadingResults = true;
    let filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    let fromDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    let toDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    let payload = {
      CATReporterIMID: this.userService.getActiveMPID(),
      fromdate: fromDate,
      todate: toDate
    }
    this.gridService.getApplicationFilterQueries(
      payload,
      APIURL.Comparative_Review_Exception_Summary,
    ).subscribe({
      next: (Element: any) => {
        this.isLoadingResults = false;
        this.CodesArray = [];
        let dataset: any = Element;
        this.CodesArray = dataset.Data;
      }, error: (err: HttpErrorResponse) => {
        this.CodesArray = [];
        this.isLoadingResults = false;
      }
    });

  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onBrowsecomCommentViewer() {
    this.isDisplayAddCommentForm = false;
    let reportDate = new Date(this.compReviewServiceService.LastExecutionCompDate[0]);
    this.commentStaticFilters = [
      { filterName: 'FromDate', filterValue: this.userService.getFirstDateOfMonth(reportDate), fieldName: 'reportDate' },
      { filterName: 'ToDate', filterValue: this.userService.getLastDateOfMonth(reportDate), fieldName: 'reportDate' }];
    this.isDisplayCommentDialog = true;
    this.selectedRow = [];
    this.userService.logUserActivity("Browse Comment Viewer", null, {
          'Text1': this.userService.userFirstName + ' Browse Comment Viewer',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.commentStaticFilters)
    });
    this.addComment();
  }

  addComment() {
    this.commentAPIDetail = {
      "GetCommentURL": APIURL.Comp_Review_Get_Comments,
      "AddCommentURL": APIURL.Comp_Review_Add_Comment,
      "Module": "Comparative-Review-Exceptions"
    };
  }


  getBrowseCommentViewerCount()
  {
    this.commentViewerService.getBrowseCommentViewerCount(this.compReviewServiceService.LastExecutionCompDate[0],"Comparative-Review-Exceptions");
  }

}